import { colors } from '@lmc/common/constants'
import { Icon, InputDatePicker } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import React from 'react'

type AntdDateFilterProps = {
  currentDate: any
  setCurrentDate: (date: any) => void
  wrapFormItem?: boolean
}

const handleArrowClick = (
  arrow: 'left' | 'right',
  currentDate: string,
  setCurrentDate: (value: unknown) => void
) => {
  if (arrow === 'left') {
    setCurrentDate(dayjs(currentDate).subtract(1, 'days'))
  } else {
    setCurrentDate(dayjs(currentDate).add(1, 'days'))
  }
}

const handleDateChange = ({
  date,
  setCurrentDate
}: {
  date: unknown
  setCurrentDate: (value: unknown) => void
}) => {
  if (!date) return setCurrentDate(dayjs())

  return setCurrentDate(date)
}

/**
@description Renders an antd date filter.

@param {object} currentDate. The current date for the screen.
Is a dayjs object.

@param {func} setCurrentDate. Sets current date.

@returns {function} AntdDateFilter.
*/

export default function AntdDateFilter(props: AntdDateFilterProps) {
  const { currentDate, setCurrentDate, wrapFormItem = false } = props

  return (
    <div style={styles.dateFilterContainer}>
      <div
        className="left-arrow-container"
        onClick={() => {
          handleArrowClick('left', currentDate, setCurrentDate)
        }}
        style={styles.arrowContainer}
      >
        <Icon name="LeftOutlined" style={styles.arrowLeft} />
      </div>
      <InputDatePicker
        format="D MMM"
        onChange={(date) => {
          handleDateChange({ ...props, date })
        }}
        defaultValue={currentDate}
        value={currentDate.format('D MMM')}
        wrapFormItem={wrapFormItem}
      />
      <div
        className="right-arrow-container"
        onClick={() => {
          handleArrowClick('right', currentDate, setCurrentDate)
        }}
        style={styles.arrowContainer}
      >
        <Icon name="RightOutlined" style={styles.arrowRight} />
      </div>
    </div>
  )
}

const styles = {
  arrowContainer: {
    cursor: 'pointer'
  },
  arrowLeft: {
    color: colors.darkgrey,
    fontSize: 12,
    paddingRight: 8
  },
  arrowRight: {
    color: colors.darkgrey,
    fontSize: 12,
    paddingLeft: 8
  },
  dateFilterContainer: {
    display: 'flex',
    alignItems: 'center'
  }
}
